import { Component, OnInit, AfterViewInit, Output, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpService } from '../../services/http.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit, AfterViewInit {

  @Output() filterClick = new EventEmitter();
  @Output() closeClick = new EventEmitter();

  arrayDescriptors = [
    { class: '', text: 'Lively' },
    { class: '', text: 'Boring' },
    { class: '', text: 'Meaningful' },
    { class: '', text: 'Meaningless' },
    { class: '', text: 'Natural' },
    { class: '', text: 'Artificial' },
    { class: '', text: 'Pleasant' },
    { class: '', text: 'Unpleasant' },
    { class: '', text: 'Familiar' },
    { class: '', text: 'Unfamiliar' },
    { class: '', text: 'Friendly' },
    { class: '', text: 'Unfriendly' },
    { class: '', text: 'Relaxing' },
    { class: '', text: 'Stressing' },
    { class: '', text: 'Informative' },
    { class: '', text: 'Uninformative' },
    { class: '', text: 'Beautiful' },
    { class: '', text: 'Ugly' },
    { class: '', text: 'Preferred' },
    { class: '', text: 'Unpreferred' }
  ];
  arrayPerceived = [
    { value: '5.0', text: 'Very quiet' },
    { value: '4.0', text: 'Quiet' },
    { value: '3.0', text: 'Fairly quiet' },
    { value: '2.0', text: 'Slightly quiet' },
    { value: '1.0', text: 'Not quiet' },
    { value: '', text: '--' }
  ];
  arrayVisual = [
    { value: '5.0', text: 'Very good' },
    { value: '4.0', text: 'Good' },
    { value: '3.0', text: 'Fairly good' },
    { value: '2.0', text: 'Slightly good' },
    { value: '1.0', text: 'Not good' },
    { value: '', text: '--' }
  ];
  arrayAccessibility = [
    { value: '5.0', text: 'Very good' },
    { value: '4.0', text: 'Good' },
    { value: '3.0', text: 'Fairly good' },
    { value: '2.0', text: 'Slightly good' },
    { value: '1.0', text: 'Not good' },
    { value: '', text: '--' }
  ];
  arrayTime = [
    { value: '1', text: 'Morning' },
    { value: '2', text: 'Afternoon' },
    { value: '3', text: 'Evening' },
    { value: '4', text: 'Night' },
    { value: '', text: '--' }
  ];
  textPerceived = this.arrayPerceived[5].text;
  textVisual = this.arrayVisual[5].text;
  textAccessibility = this.arrayAccessibility[5].text;
  textTime = this.arrayTime[4].text;
  valuePerceived = this.arrayPerceived[5].value;
  valueVisual = this.arrayVisual[5].value;
  valueAccessibility = this.arrayAccessibility[5].value;
  valueTime = this.arrayTime[4].value;
  descriptor = [];
  isChecked = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private httpService: HttpService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.setValue((<HTMLInputElement>document.getElementById('noise-level')).value);
      document.getElementById('noise-level').oninput = () => {
        this.showValue((<HTMLInputElement>document.getElementById('noise-level')).value);
      };
      window.addEventListener('click', () => {
        for (let i = 0; i < document.getElementsByClassName('show-visual').length; i++) {
          if (event.target !== document.getElementsByClassName('show-visual')[i]) {
            document.getElementsByClassName('show-visual')[i].nextElementSibling.classList.remove('show');
          }
        }
      });
    }
  }

  ngAfterViewInit() {
    this.getDescriptor();
  }

  showValue(val) {
    if (isPlatformBrowser(this.platformId)) {
      const thumb = document.getElementById('noisethumb');
      const shell = document.getElementById('noiseshell');
      const track = document.getElementById('noisetrack');
      const fill = document.getElementById('noisefill');
      const range = document.getElementById('noisevalue');
      const noise = (<HTMLInputElement>document.getElementById('noise-level'));
      const selector = document.getElementById('list-noise').children;
      const pc = (val - 20) / (parseInt(noise.max, 0) - parseInt(noise.min, 0));
      const thumbsize = thumb.offsetHeight;
      const bigval = shell.offsetWidth;
      const tracksize = bigval - thumbsize;
      const filloffset = 10;
      const bordersize = 2;
      const loc = pc * tracksize;
      range.innerHTML = val;
      range.style.top = '0px';
      range.style.left = loc + 'px';
      thumb.style.top = '0px';
      thumb.style.left = loc + 'px';
      fill.style.top = filloffset + bordersize + 'px';
      fill.style.left = '20px';
      fill.style.width = loc + (thumbsize / 2) + 'px';
      track.style.width = bigval - 4 + 'px';
      track.style.left = '2px';
      track.style.top = filloffset + bordersize + 'px';
      let index, position;
      for (let i = 0; i < selector.length; i++) {
        index = selector[i];
        position = parseInt(index.textContent, 0);
        if (isNaN(position)) {
          position = 80;
        }
        index.style.left = ((position - 20) / (parseInt(noise.max, 0) - parseInt(noise.min, 0))) * tracksize + 'px';
      }
    }
  }

  setValue(val) {
    if (isPlatformBrowser(this.platformId)) {
      (<HTMLInputElement>document.getElementById('noise-level')).value = val;
      this.showValue(val);
    }
  }

  onChecked(event) {
    if (isPlatformBrowser(this.platformId)) {
      this.isChecked = event.target.checked;
      const disable = document.getElementById('noise-level');
      if (disable.hasAttribute('disabled')) {
        disable.removeAttribute('disabled');
      } else {
        disable.setAttribute('disabled', 'disabled');
      }
    }
  }

  toggleSelect(event) {
    event.target.nextElementSibling.classList.toggle('show');
    const nextElement = event.target.nextElementSibling;
    const idElement = nextElement.getAttribute('id');
    const child = nextElement.children;
    for (let i = 0; i < child.length; i++) {
      child[i].addEventListener('click', () => {
        event.target.nextElementSibling.classList.remove('show');
        if (idElement === 'perceived') {
          this.valuePerceived = child[i].getAttribute('data-value');
          this.textPerceived = child[i].textContent;
        } else if (idElement === 'visual') {
          this.valueVisual = child[i].getAttribute('data-value');
          this.textVisual = child[i].textContent;
        } else if (idElement === 'accessibility') {
          this.valueAccessibility = child[i].getAttribute('data-value');
          this.textAccessibility = child[i].textContent;
        } else if (idElement === 'time') {
          this.valueTime = child[i].getAttribute('data-value');
          this.textTime = child[i].textContent;
        }
      });
    }
  }

  getDescriptor() {
    if (isPlatformBrowser(this.platformId)) {
      const des = document.getElementById('list-descriptors').children;
      this.descriptor = [];
      for (let i = 0; i < des.length; i++) {
        if (des[i].getAttribute('class') === 'choose') {
          this.descriptor.push(des[i].getAttribute('data-value'));
        }
        des[i].addEventListener('click', () => {
          if (des[i].getAttribute('class') === 'choose') {
            des[i].classList.remove('choose');
            this.descriptor.splice(this.descriptor.indexOf(des[i].getAttribute('data-value')), 1);
          } else {
            des[i].setAttribute('class', 'choose');
            this.descriptor.push(des[i].getAttribute('data-value'));
          }
        });
      }
    }
  }

  applyFilter() {
    let noiseValue;
    if (!this.isChecked) {
      noiseValue = 0;
    } else {
      if (isPlatformBrowser(this.platformId)) {
        noiseValue = (<HTMLInputElement>document.getElementById('noise-level')).value;
      }
    }
    let lang = 'en';
    if (isPlatformBrowser(this.platformId)) {
      lang = sessionStorage.getItem('language');
    }
    const descriptor = this.descriptor.join('|-|');
    this.httpService.filterArea(noiseValue, descriptor, this.valuePerceived, this.valueVisual, this.valueAccessibility, this.valueTime, lang)
      .subscribe((data) => {
        if (data.err_code === 0) {
          this.filterClick.emit(data.data.survey);
          this.closeFilter();
          this.scrollTo(document.getElementById('filter'), 0, 200);
        } else {
          console.log(data);
        }
      });
  }

  resetFilter() {
    let lang = 'en';
    if (isPlatformBrowser(this.platformId)) {
      lang = sessionStorage.getItem('language');
      this.setValue(40);
      (<HTMLInputElement>document.getElementById('checklevel')).checked = false;
      this.isChecked = false;
      document.getElementById('noise-level').setAttribute('disabled', 'disabled');
      this.descriptor = [];
      const des = document.getElementById('list-descriptors').children;
      for (let i = 0; i < des.length; i++) {
        des[i].classList.remove('choose');
      }
      this.textPerceived = this.arrayPerceived[5].text;
      this.textVisual = this.arrayVisual[5].text;
      this.textAccessibility = this.arrayAccessibility[5].text;
      this.textTime = this.arrayTime[4].text;
      this.valuePerceived = this.arrayPerceived[5].value;
      this.valueVisual = this.arrayVisual[5].value;
      this.valueAccessibility = this.arrayAccessibility[5].value;
      this.valueTime = this.arrayTime[4].value;
      this.scrollTo(document.getElementById('filter'), 0, 200);
      this.closeFilter();
    }
    this.httpService.filterArea(0, '', this.valuePerceived, this.valueVisual, this.valueAccessibility, this.valueTime, lang)
      .subscribe((data) => {
        if (data.err_code === 0) {
          this.filterClick.emit(data.data.survey);
        } else {
          console.log(data);
        }
      });
  }

  closeFilter() {
    this.closeClick.emit();
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('show-filter', 'false');
    }
  }

  scrollTo(element, to, duration) {
    let start, change, currentTime, increment, val, animateScroll, easeInOutQuad;
    start = element.scrollTop;
    change = to - start;
    currentTime = 0;
    increment = 20;
    // t = current time, b = start value, c = change in value, d = duration
    easeInOutQuad = function (t, b, c, d) {
      t /= d / 2;
      if (t < 1) {
        return c / 2 * t * t + b;
      }
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    };
    animateScroll = function () {
      currentTime += increment;
      val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  }

}
